module.exports = __webpack_public_path__ + "static/img/wechat.45dc21eb.png";